// Generated by Jenkins (master #121, env=dev) - do not edit here.
export const API_CONFIG = {
  baseUrl: 'https://api.dev.sale4all.co.il/',
  apiUrl: 'https://api.dev.sale4all.co.il',
  wsUrl: 'wss://api.dev.sale4all.co.il/ws/',
};
